import dayjs from 'dayjs';
import * as yup from 'yup';

declare module 'yup' {
  interface DateSchema {
    dateOnlyFormat(): DateSchema;
  }
  // interface StringSchema {
  //   italianDate(): StringSchema;
  // }
}

const invalidDate = new Date('');

yup.addMethod(yup.date, 'dateOnlyFormat', function () {
  return this.transform(function (value: any, originalValue) {
    if (!this.isType(value) || value == null) return value;

    value = dayjs(originalValue, [
      'YYYY-MM-DD',
      'DD-MM-YYYY',
      'DD/MM/YYYY',
      'MMM DD YYYY hh:mmA',
      'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
    ]);

    return value.isValid() ? value.toDate() : invalidDate;
  });
});
